/** Paleta compartida del módulo SIA (capacitación). */
export const SIA_NAVY = '#0d1b2a'
export const SIA_GOLD = '#c9a227'
export const SIA_GOLD_ACTIVE_BG = '#d4af37'
export const SIA_GOLD_ACTIVE_TEXT = '#111111'
